export const ADMIN_APP_URL = import.meta.env.VITE_ADMIN_APP_URL || "https://console-yeati.co";

export const ADMIN_APP_ORIGIN = new URL(ADMIN_APP_URL).origin;
